import { render, staticRenderFns } from "./Pesticides.html?vue&type=template&id=ed268d08&external"
import script from "./Pesticides.js?vue&type=script&lang=js&external"
export * from "./Pesticides.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports